import PropTypes from "prop-types";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useRewampT } from "../../../localisation";
import RewampDateInput from "../../schemeApply/formEngine/widgets/RewampDateInput";
import { FILTER_DATE_INPUT_SX } from "../rewampFilterLayout";

const EARLIEST = new Date(1900, 0, 1);
const parseDay = (iso) => (iso ? new Date(`${iso}T00:00:00`) : null);

// value = { from, to } as "YYYY-MM-DD"; bounds keep From ≤ To ≤ today.
export default function FilterDateRangeField({ controlId, value, onChange, error, describedBy, clearable }) {
  const tRewamp = useRewampT();
  const { from = "", to = "" } = value ?? {};
  const today = new Date();
  const fromDay = parseDay(from);
  const toDay = parseDay(to);

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
      <Box sx={FILTER_DATE_INPUT_SX}>
        <RewampDateInput
          inputId={controlId}
          ariaLabel={tRewamp("FILTER_ROW.DATE_FROM")}
          placeholder={tRewamp("FILTER_ROW.FROM")}
          iconColor="primary.main"
          value={from}
          onChange={(next) => onChange({ from: next, to })}
          error={error && !from}
          ariaDescribedBy={describedBy}
          minDate={EARLIEST}
          maxDate={toDay ?? today}
          separator="/"
        />
      </Box>
      <Box sx={FILTER_DATE_INPUT_SX}>
        <RewampDateInput
          inputId={controlId ? `${controlId}-to` : undefined}
          ariaLabel={tRewamp("FILTER_ROW.DATE_TO")}
          placeholder={tRewamp("FILTER_ROW.TO")}
          iconColor="primary.main"
          value={to}
          onChange={(next) => onChange({ from, to: next })}
          error={error && !to}
          ariaDescribedBy={describedBy}
          minDate={fromDay ?? EARLIEST}
          maxDate={today}
          separator="/"
        />
      </Box>
      {clearable && (from || to) && (
        <IconButton size="small" aria-label={tRewamp("FILTER_ROW.DATE_CLEAR")} onClick={() => onChange({ from: "", to: "" })}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}

FilterDateRangeField.propTypes = {
  controlId: PropTypes.string,
  value: PropTypes.shape({ from: PropTypes.string, to: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  describedBy: PropTypes.string,
  clearable: PropTypes.bool,
};

FilterDateRangeField.defaultProps = {
  controlId: undefined,
  value: { from: "", to: "" },
  error: false,
  describedBy: undefined,
  clearable: true,
};
